import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router'

import { getAsyncTaskId } from '../../utils/async'
import { isSamePage } from '../../utils/common'
import { getNotificationViewTableRedirectPath } from '../../utils/link'
import { getMassActionsSuccessItemsLength } from '../../utils/massActions'
import { useNotification } from '../useNotification'
import { useRefetchCounters } from '../useRefetchCounters'

import { checkTaskStatus } from './useMassActions.utils'

export function useMassActions({
  getAsyncNotificationText,
  getMassSuccessItemsLength = getMassActionsSuccessItemsLength,
  getNotificationTitle,
  shouldFetchCounter,
  onSuccessHandler,
}) {
  const refetchCounters = useRefetchCounters()

  const { t } = useTranslation()

  const location = useLocation()

  const {
    handleAddErrorNotification,
    handleAddInfoNotification,
    handleAddSuccessNotification,
  } = useNotification()

  function handleAddFinishMassActionNotification(data, params) {
    const successItemsCount = getMassSuccessItemsLength(data)

    const notificationHandler =
      successItemsCount === 0
        ? handleAddErrorNotification
        : handleAddSuccessNotification

    if (successItemsCount > 0 && shouldFetchCounter) {
      refetchCounters()
    }

    // window.location.pathname because of location is't updating
    const samePage = isSamePage(params.pathname)

    notificationHandler({
      ...(params.task && !samePage
        ? {
            linkProps: {
              title:
                params.linkProps?.title ||
                t('Notification.CommonAsyncMassActionFinishedViewTableKey'),
              to:
                params.linkProps?.to ||
                getNotificationViewTableRedirectPath(
                  params.pathname,
                  params.sub
                ),
            },
            text: getAsyncNotificationText?.({ ...params, t }),
          }
        : null),
      title: getNotificationTitle({
        action: params.action,
        count: successItemsCount,
        t,
        totalCount: params.totalCount,
      }),
    })

    if (samePage) {
      onSuccessHandler?.()
    }
  }

  function handleAddAsyncMassActionNotification(params) {
    const preparedParams = { ...params, pathname: location.pathname }

    handleAddInfoNotification(
      'Notification.CommonAsyncMassActionInProcessTitleKey'
    )

    checkTaskStatus(preparedParams, handleAddFinishMassActionNotification)
  }

  return {
    getAsyncTaskId,
    handleAddAsyncMassActionNotification,
    handleAddFinishMassActionNotification,
  }
}
